import React, { useMemo } from 'react';
import { useFetchSites } from './useFetchSites';
import { useSitesData } from './useSitesData';
import { useQueryNavigation } from '../shared';

export default function useSitesPage() {
  const {
    currentParams: { search: searchValue },
  } = useQueryNavigation();

  const { sites, isLoading, getSitesData } = useFetchSites();

  const { data } = useSitesData(
    searchValue ? sites?.filter((site) => site.site_name.toLowerCase().includes(searchValue.toLowerCase())) : sites
  );

  return {
    isLoading,
    data,
    getSitesData,
  };
}
